export default __webpack_public_path__ + "static/media/set-short-4.7cddb31b.png";